import { observer } from "mobx-react-lite";
import React, { FC, useEffect, useRef } from "react";
import styles from "./index.module.scss";
import { useClickAway } from "ahooks";
import config from "@/config";
interface DialogProps {
  visible: boolean;
  title: string;
  children?: React.ReactNode;
  onClose: () => void;
  subtitle?: string;
}
const Dialog: FC<DialogProps> = (props) => {
  const { title, subtitle, children, onClose, visible } = props;
  const dialogContentRef = useRef<HTMLDivElement>(null);
  useClickAway(() => {
    onClose && onClose();
  }, [dialogContentRef]);
  useEffect(() => {
    //监听esc键盘事件
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        onClose && onClose();
      }
    };
    document.addEventListener("keydown", handleEsc);
    return () => {
      document.removeEventListener("keydown", handleEsc);
    };
  }, []);
  if (!visible) return null;
  return (
    <div className={styles.dialogWrapper}>
      <div className={styles.dialogContent} ref={dialogContentRef}>
        <img
          src={`${config.buildCdnBaseUrl}assets/creator/bytesize_close.png`}
          alt=""
          className={styles.close}
          onClick={onClose}
        />
        {title && <p className={styles.title}>{title}</p>}
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        {children && children}
      </div>
    </div>
  );
};
export default observer(Dialog);
